import React from 'react'

import { Button } from '../../../../components'

import './competitorgapcard.scss'

const CompetitorGapCard = ({ gap, nls, onDetalhe }) => {
  if (!gap) return null

  return (
    <div
  className='box-competitor-gap-card'
  data-cy='competitorgaps-card'
  data-cy-id={gap.gapId}
>
      <div className='box-competitor-gap-card-header'>
        <div className='box-competitor-gap-card-badges'>
          <span className='box-competitor-gap-card-badge'>
            {gap.status || '-'}
          </span>

          <span className='box-competitor-gap-card-badge'>
            {gap.periodo || '-'}
          </span>

          <span className='box-competitor-gap-card-badge'>
            {gap.opportunityType || '-'}
          </span>
        </div>

        <div className='box-competitor-gap-card-validity'>
          {nls.validUntil}: {gap.validoAte || '-'}
        </div>
      </div>

      <h3 className='box-competitor-gap-card-title'>
        {gap.titulo || '-'}
      </h3>

      <div className='box-competitor-gap-card-meta'>
        <div className='box-competitor-gap-card-meta-item'>
          <span>{nls.competitor}:</span>
          <strong>{gap.empresaConcorrente || '-'}</strong>
        </div>

        <div className='box-competitor-gap-card-meta-item'>
          <span>{nls.scope}:</span>
          <strong>{gap.escopo || '-'}</strong>
        </div>

        <div className='box-competitor-gap-card-meta-item'>
          <span>{nls.analysisPeriod}:</span>
          <strong>
            {gap.dataInicioAnalise || '-'} - {gap.dataFimAnalise || '-'}
          </strong>
        </div>

        <div className='box-competitor-gap-card-meta-item'>
          <span>{nls.createdAt}:</span>
          <strong>{gap.dataCriacao || '-'}</strong>
        </div>
      </div>

      <p className='box-competitor-gap-card-summary'>
        {gap.resumo || '-'}
      </p>

      <div className='box-competitor-gap-card-actions'>
        <Button
  data-cy='competitorgaps-action'
  data-cy-key='details'
  data-cy-effect='read'
  color='primary'
  onClick={() => onDetalhe(gap)}
>
  {nls.detail}
</Button>
      </div>
    </div>
  )
}

export default CompetitorGapCard